import { Intent } from '@blueprintjs/core';
import { toastQueue, ToastRegion } from '@launchpad-ui/components';

type NotificationOptions = {
  intent: Intent;
  icon?: string;
  message: string;
};

const intentToStatus = (intent: Intent) => {
  switch (intent) {
    case Intent.SUCCESS:
      return 'success' as const;
    case Intent.DANGER:
      return 'error' as const;
    case Intent.WARNING:
      return 'info' as const;
    default:
      return 'info' as const;
  }
};

export const Notifications = {
  show: (options: NotificationOptions) => {
    const status = intentToStatus(options.intent);

    toastQueue.add({
      title: options.message,
      status,
      description: undefined,
      action: undefined,
    });
  },
};

export const NotificationRegion = () => <ToastRegion queue={toastQueue} placement="bottom" />;
